import { SessionFormResourceModal } from './SessionFormResourceModal';
export default SessionFormResourceModal;